import { render, staticRenderFns } from "./CountryLangManager.vue?vue&type=template&id=72ff68c7&scoped=true"
import script from "./CountryLangManager.vue?vue&type=script&lang=js"
export * from "./CountryLangManager.vue?vue&type=script&lang=js"
import style0 from "./CountryLangManager.vue?vue&type=style&index=0&id=72ff68c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff68c7",
  null
  
)

export default component.exports